import { tracked } from '@glimmer/tracking';
import { TrackedObject } from '@ember-compat/tracked-built-ins';
import Constants from '../utils/constants';
import { action } from '@ember/object';

export default class ModalHandler {
  open = new TrackedObject({});
  data = new TrackedObject({});
  @tracked showAbout = false;
  @tracked showFeedback = false;
  @tracked showHelp = false;
  @tracked showChooseDac = false;
  @tracked showChooseSignalPart = false;
  @tracked showNotification = false;
  @tracked openString = '';
  notification = {};

  constructor() {
    Object.keys(Constants.MODAL_TYPES).forEach((key) => {
      const type = Constants.MODAL_TYPES[key];
      this.open[type.value] = type.default;
    });
    this.resetOpenString();
  }

  resetOpenString() {
    let result = '';
    const openKeys = Object.keys(this.open);
    openKeys.forEach((key, index) => {
      result = result.concat(`${key}=${this.open[key]}`);
      if (index != openKeys.length - 1) {
        result = result.concat(';');
      }
    });

    this.openString = result;
  }

  show(type, modalData = null) {
    this.open[type] = true;
    if (modalData) {
      this.data[type] = modalData;
    }
    this.toggleModal(type, true);
    this.resetOpenString();
  }

  hide(type) {
    this.open[type] = false;
    if (type in this) {
      delete this.data[type];
    }
    this.resetOpenString();
  }

  toggleModal(type, show = false) {
    switch (type) {
      case 'about':
        this.showAbout = show;
        break;
      case 'feedback':
        this.showFeedback = show;
        break;
      case 'help':
        this.showHelp = show;
        break;
      case 'choose-dac':
        this.showChooseDac = show;
        break;
      case 'choose-signal-chain-part':
        this.showChooseSignalPart = show;
        break;
      case 'notification':
        this.showNotification = show;
        break;
      default:
        console.error('Invalid modal');
    }
  }

  @action displayNotification(title, message) {
    this.toggleModal('notification', true);
    this.notification.title = title;
    this.notification.message = message;
  }

  @action closeNotification() {
    this.toggleModal('notification', false);
    this.notification.title = '';
    this.notification.message = '';
  }

  @action closeModal(type) {
    this.toggleModal(type, false);
  }
}
